export default __webpack_public_path__ + "assets/86d64dfc4a0541f9240cc722f202e695.png";